import { ChangeDetectorRef, Component, Inject, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatListModule } from '@angular/material/list';

const MODULES: any[] = [
  MatButtonModule,
  MatIconModule,
  MatFormFieldModule,
  FormsModule,
  ReactiveFormsModule,
  MatListModule
];

@Component({
  selector: 'cancel-BottomSheet',
  standalone: true,
  imports: [MODULES],
  templateUrl: './cancelBottomSheet.component.html',
  styleUrl: './cancelBottomSheet.component.css',
})
export class CancelBottomSheetComponent {
  readonly dialogRef = inject(MatBottomSheetRef<CancelBottomSheetComponent>);

  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: { mode: string }) {
  }

  onYesClick(): void {
    this.dialogRef.dismiss('yes')
  }

  onNoClick(): void {
    this.dialogRef.dismiss('no');
  }

  onOkClick(): void {
    this.dialogRef.dismiss('ok');
  }
}
